export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#B78D52',
    light: '#EBEBE4',
    after: '#6B5A9A',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FFFFFF',
    light: 'rgba(255, 255, 255, 0.2)',
    contrastText: '#22211F',
  },
  text: {
    content: '#25272C',
    brand: '#003F2A',
    brandHero: '#3C4B1E',
    button: '#0C0F06',
    primary: '#001A11',
    secondary: '#3E444E',
    tertiaryLight: '#49515B',
    tertiary: '#0F0F0F',
    alternate: '#1F3B61',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    contrastText: '#22211F',
    brandBorder: '#D2AB4F',
    blueBorder: '#6E93A3',
    /* Forest Family design tokens */
    nav: '#222925',
    section: '#313B33',
    heroAccent: '#BEA474',
    stepBorder: '#242B28',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    brandLight: '#003964',
    benefits: '#3F4F31',
    benefitsCard: '#EBE8E5',
    heroInner: '#FDFFF9',
    heroOuter: '#D2AB4F',
    tabActive: '#F7F8F8',
    fill: '#FAFAFA',
    hero1: '#2F3A17',
    heroMobile: '#222B1B',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#4E4E4E',
    footer: '#3F4F31',
    headerBorder: 'rgba(63, 79, 49, 0.2)',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#B78D52',
    tableSubhead: '#DEDDD2',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#B6BFA5',
    secondary: '#F5F3F0',
    light: '#EDE7DE',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#BBE6FE',
    offer: '#D7FFF7',
    stepperCompleted: '#081425',
    border: '#D7DBE0',
  },
  surface: {
    light: '#B6BFA5',
    grey: '#FAFAFA',
    pricing: '#F3EFEB',
    learnMore: '#DEDDD2',
    header: '#FAFAFA',
    planCard: '#F7F8F8',
    switch: '#313E50',
    loginCta: '#FEFAF1',
    tabAccent: '#B0D0E8',
  },
  overlay: {
    dark60: 'rgba(0, 0, 0, 0.6)',
    dark45: 'rgba(0, 0, 0, 0.45)',
    dark72: 'rgba(0, 0, 0, 0.72)',
    clear: 'rgba(0, 0, 0, 0)',
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
